import { appContextSlice } from './slice';

export const {
    toggleDividedEachPageAction,
    resetDividedEachPageAction,
    setAppStepAction,
    addErrors,
    clearErrors,
    setPropsAction
} = appContextSlice.actions;
